import { UserInterface } from '../../interfaces/user';

export interface UserState {
  readonly error: boolean;
  readonly loading: boolean;
  readonly token: string;
  readonly user: UserInterface;
};

export enum ActionTypes {
  AUTHENTICATION = 'user/AUTHENTICATION',
  AUTHENTICATION_SUCCESS = 'user/AUTHENTICATION_SUCCESS',
  AUTHENTICATION_ERROR = 'user/AUTHENTICATION_ERROR',
  DEFINE_USER = 'user/DEFINE_USER',
  REMOVE_USER = 'user/REMOVE_USER',
  RESET_STATE = 'user/RESET_STATE',
};

export interface AuthenticationAction {
  type: ActionTypes.AUTHENTICATION;
};

export interface AuthenticationSuccessAction {
  type: ActionTypes.AUTHENTICATION_SUCCESS;
  token: string;
  user: UserInterface;
};

export interface AuthenticationErrorAction {
  type: ActionTypes.AUTHENTICATION_ERROR;
};

export interface DefineUser {
  type: ActionTypes.DEFINE_USER;
  user: UserInterface;
  token: string;
};

export interface RemoveUser {
  type: ActionTypes.REMOVE_USER;
};

export interface ResetStateAction {
  type: ActionTypes.RESET_STATE;
};

export type Action =
  | AuthenticationAction
  | AuthenticationSuccessAction
  | AuthenticationErrorAction
  | DefineUser
  | RemoveUser
  | ResetStateAction;
